import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, UrlTree } from '@angular/router';
import { EnvironmentActions } from '@app/core/actions';
import * as fromRoot from '@app/reducers';
import { Store, select } from '@ngrx/store';
import { Language } from '@smash-sdk/uploader/dist/interface/Transfer';
import { Observable, ReplaySubject, of } from 'rxjs';
import { distinctUntilChanged, mergeMap, takeUntil } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SwitchLanguageGuard implements CanActivate {

  constructor(
    private store$: Store<fromRoot.State>
  ) { }

  canActivate(next: ActivatedRouteSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    this.store$.dispatch(EnvironmentActions.SelectLanguage({ language: next.routeConfig.path as Language }));
    return this.selectLanguage(next.routeConfig.path).pipe(mergeMap((ok) => {
      if (ok) {
        return of(true)
      }
    }));
  }

  selectLanguage(targetLanguage): Observable<boolean> {
    const selectLanguage$ = new ReplaySubject<boolean>();
    this.store$.pipe(
      select(fromRoot.getSelectedLanguage),
      distinctUntilChanged(),
      takeUntil(selectLanguage$),
    ).subscribe((selectedLanguage: string) => {
      if (selectedLanguage === targetLanguage) {
        selectLanguage$.next(true);
      }
    });
    return selectLanguage$.asObservable();
  }

}
